import { CommonModule } from '@angular/common';
import { TopicRoutingModule } from './topic-routing.module';
import { NgModule, APP_INITIALIZER } from '@angular/core';
import { ExercisesComponent } from './exercises/exercises.component';
import { FormsModule } from '@angular/forms';
import { TopicService } from './topic.service';
import { LanguageProvider } from './language.provider';
import { TopicComponent } from './topic/topic.component';
import { TExercisesComponent } from './t-exercises/t-exercises.component';
import { DndModule } from 'ng2-dnd';
import { TAllExercisesComponent } from './t-all-exercises/t-all-exercises.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ExamComponent } from './exam/exam.component';
import { EvaluationComponent } from './evaluation/evaluation.component';
import { SharedModule } from '../shared/shared.module';
import { OpenQuestionComponent } from './open-question/open-question.component';
import { TOpenQuestionComponent } from './t-open-question/t-open-question.component';
import { TExamComponent } from './t-exam/t-exam.component';
import { TAllExamsComponent } from './t-all-exams/t-all-exams.component';
import { MultipleChoiceComponent } from './multiple-choice/multiple-choice.component';
import { TMultipleChoiceComponent } from './t-multiple-choice/t-multiple-choice.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ImageCompressionComponent } from './image-compression/image-compression.component';
import { TImageCompressionComponent } from './t-image-compression/t-image-compression.component';
import { ImageEditorComponent } from './image-editor/image-editor.component';
import { WordCompressionComponent } from './word-compression/word-compression.component';
import { TWordCompressionComponent } from './t-word-compression/t-word-compression.component';
import { WordDecompressionComponent } from './word-decompression/word-decompression.component';
import { TWordDecompressionComponent } from './t-word-decompression/t-word-decompression.component';
import { CreateImagesComponent } from './create-images/create-images.component';
import { TCreateImagesComponent } from './t-create-images/t-create-images.component';
import { NewImageCompressionComponent } from './new-image-compression/new-image-compression.component';
import { TNewImageCompressionComponent } from './t-new-image-compression/t-new-image-compression.component';
import { NewImageDecompressionComponent } from './new-image-decompression/new-image-decompression.component';
import { TNewImageDecompressionComponent } from './t-new-image-decompression/t-new-image-decompression.component';
import { DiscoverComponent } from './discover/discover.component';
import { TDiscoverComponent } from './t-discover/t-discover.component';
import { LetterCompressionComponent } from './letter-compression/letter-compression.component';
import { TLetterCompressionComponent } from './t-letter-compression/t-letter-compression.component';
import { UniqueArrayDirective } from './unique-array.directive';
import { LetterDecompressionComponent } from './letter-decompression/letter-decompression.component';
import { TLetterDecompressionComponent } from './t-letter-decompression/t-letter-decompression.component';
import { CreateCompressionComponent } from './create-compression/create-compression.component';
import { TCreateCompressionComponent } from './t-create-compression/t-create-compression.component';
import { ExampleComponent } from './example/example.component';
import { TExampleComponent } from './t-example/t-example.component';
import { PlaygroundComponent } from './playground/playground.component';

@NgModule({
  imports: [
    CommonModule,
    TopicRoutingModule,
    FormsModule,
    DndModule,
    BrowserAnimationsModule,
    NgbModule,
    SharedModule
  ],providers: [TopicService,
    LanguageProvider,
    { provide: APP_INITIALIZER, useFactory: languageProviderFactory, deps: [LanguageProvider], multi: true }],
  declarations: [ExercisesComponent,
    TopicComponent,
    TExercisesComponent, 
    TAllExercisesComponent, 
    ExamComponent, 
    EvaluationComponent, 
    OpenQuestionComponent, 
    TOpenQuestionComponent, 
    TExamComponent, 
    TAllExamsComponent, 
    MultipleChoiceComponent, 
    TMultipleChoiceComponent, ImageCompressionComponent, TImageCompressionComponent, ImageEditorComponent, WordCompressionComponent, TWordCompressionComponent, WordDecompressionComponent, TWordDecompressionComponent, CreateImagesComponent, TCreateImagesComponent, NewImageCompressionComponent, TNewImageCompressionComponent, NewImageDecompressionComponent, TNewImageDecompressionComponent, DiscoverComponent, TDiscoverComponent, LetterCompressionComponent, TLetterCompressionComponent, UniqueArrayDirective, LetterDecompressionComponent, TLetterDecompressionComponent, CreateCompressionComponent, TCreateCompressionComponent, ExampleComponent, TExampleComponent, PlaygroundComponent]
})
export class CompressionModule { }

export function languageProviderFactory(provider: LanguageProvider) {
  return () => provider.load();
}
